import axios from '@/common/axios'
import urls from '@/common/urls'
import tips from '@/common/tips'

let cfg = {
  project: "ERP",
  type: "erpFile"
}
async function uploadFile(files, reg = 'jpg|jpeg|png|PNG|JPG', key, url = '', item) {
  console.log(files, '22222222222222222222s');
  if (!files) return;
  //reg=all表示所有类型
  let RegObj = reg == "all" ? new RegExp("^(.+)$") : new RegExp(`^(${reg})$`, "i");
  let fileList = [];
  if (files instanceof FileList) {
    for (const file of files) {
      let type = file.name.split('.').slice(-1)
      if (!RegObj.test(type)) {
        tips.error({ text: `类型必须是${reg.replace(/\|/g, ',')}` })
        return '';
      }
      fileList.push(file)
    }
  } else {
    let type = files.name.split('.').slice(-1)
    if (!RegObj.test(type)) {
      tips.error({ text: `类型必须是${reg.replace(/\|/g, ',')}` })
      return '';
    }
    fileList.push(files)
  }
  let data = await QuestFile(fileList, key, url, item)
  return url ? data : data
}


async function QuestFile(files, key = 'file', url = '', item = {}) {
  item = { ...cfg, ...item }
  let data = new FormData()
  files.forEach(x => {
    data.append(key, x)
  });
  for (let i in item) {
    data.append(i, item[i])
  }
  url = url || urls.upload.uploadFile;
  return new Promise(resolve => {
    axios.post(url, data).then((res) => {
      resolve(res)
    }).catch((err) => {
      resolve(err)
    })
  })
}

async function uploadBase64(file, url, item) {
  let data = await QuestFile(file, 'file', url || urls.upload.uploadBase64, item);
  return data.url;
}

export default {
  uploadFile,
  QuestFile,
  uploadBase64
}